import React, { useLayoutEffect, useRef, useState } from 'react';
import { DropDownMenu, useIsMobileResolution } from '@philips-internal/oswald-ui-components';
import { ReactComponent as NavigationLeftIcon } from '../../../../resources/assets/DLS_Navigation.svg';
import { SPOTLIGHT_PARENT_SLIDEBAR_SELECTOR } from '../spotlight-constants.js';
import { ExternalContent, LogoutLink, MobileMenu, UserAvatar } from './components/index.js';
function UserMenu(props) {
    const { externalFragment, location, applicationTitle, logoutExpression, showSubMenuHeader, onClick, } = props;
    const [showMobileMenu, setMobileMenuVisibility] = useState(false);
    const isMobileResolution = useIsMobileResolution();
    const userMenuRef = useRef(null);
    const [hasSlidebarAsParent, setHasSlidebarAsParent] = useState(false);
    useLayoutEffect(() => {
        if (!userMenuRef.current) {
            return;
        }
        const slidebar = userMenuRef.current?.closest(SPOTLIGHT_PARENT_SLIDEBAR_SELECTOR);
        setHasSlidebarAsParent(Boolean(slidebar?.contains(userMenuRef.current)));
    }, [userMenuRef?.current]);
    const handleMobileMenuVisibility = () => {
        setMobileMenuVisibility(prevShowMobileMenu => !prevShowMobileMenu);
    };
    const renderMobileCustomMenu = () => {
        return (React.createElement("div", { className: "c-spotlight__user-menu", onClick: handleMobileMenuVisibility, ref: userMenuRef },
            React.createElement(UserAvatar, { onClick: onClick }),
            React.createElement(NavigationLeftIcon, { className: "c-module-selector__module-group-navigation" }),
            React.createElement(MobileMenu, { applicationTitle: applicationTitle, handleVisibility: handleMobileMenuVisibility, logoutExpression: logoutExpression, showMobileMenu: showMobileMenu, showSubMenuHeader: showSubMenuHeader })));
    };
    const renderMobileDefaultMenu = () => {
        return (React.createElement("div", { className: "c-spotlight__default-menu", ref: userMenuRef },
            React.createElement(UserAvatar, { onClick: onClick }),
            React.createElement(LogoutLink, { logoutExpression: logoutExpression })));
    };
    if (isMobileResolution || hasSlidebarAsParent) {
        return externalFragment ? renderMobileCustomMenu() : renderMobileDefaultMenu();
    }
    return (React.createElement(DropDownMenu, { innerRef: userMenuRef, uuid: "spotlight-dropdown-uuid" },
        React.createElement("div", { slot: "header" },
            React.createElement(UserAvatar, { onClick: onClick })),
        React.createElement("div", { className: "c-spotlight__dropdown-menu", slot: "content" },
            location,
            React.createElement(ExternalContent, null),
            React.createElement(LogoutLink, { logoutExpression: logoutExpression }))));
}
export { UserMenu, };
//# sourceMappingURL=user-menu.js.map